import { createContext, ReactNode, useEffect, useReducer } from 'react';

import { MovFundosContextType } from '../types/MovimentacaoFundosType';

//Types
type State = MovFundosContextType;

type Action = {
  type: MovimentacaoFundosActions;
  payload: any;
};

type ContextType = {
  state: State;
  setState: (action: Action) => void;
};

type MovimentacaoFundosProviderProps = {
  children: ReactNode;
};

const initialValues: State = {
  cpf: '',
  data_nascimento: '',
  id: 0,
  ev: 0,
  id_contrato: 0,
  nome_cliente: '',
  nome_produto: '',
  status: '',
  telefone: '',
  numero_proposta: 0,
  valor_saldo: 0,

  id_fundo_origem: 0,
  saldo_inicial: 0,
  nome_fundo: ''
};

//Context
export const MovimentacaoFundosContext = createContext<ContextType | undefined>(
  undefined
);

//Reducer
export enum MovimentacaoFundosActions {
  // Proposta
  setCpf,
  setData_nascimento,
  setId,
  setEV,
  setId_contrato,
  setNome_cliente,
  setNome_produto,
  setStatus,
  setTelefone,
  setNumero_proposta,
  setValor_saldo,
  setProposta,

  //Fundo origem
  setIdFundoOrigem,
  setSaldoInicial,
  setNomeFundo
}

const MovimentacaoFundosReducer = (state: State, action: Action) => {
  switch (action.type) {
    // Proposta
    case MovimentacaoFundosActions.setCpf:
      return { ...state, cpf: action.payload };
    case MovimentacaoFundosActions.setData_nascimento:
      return { ...state, data_nascimento: action.payload };
    case MovimentacaoFundosActions.setId:
      return { ...state, id: action.payload };
    case MovimentacaoFundosActions.setEV:
      return { ...state, ev: action.payload };
    case MovimentacaoFundosActions.setId_contrato:
      return { ...state, id_contrato: action.payload };
    case MovimentacaoFundosActions.setNome_cliente:
      return { ...state, nome_cliente: action.payload };
    case MovimentacaoFundosActions.setNome_produto:
      return { ...state, nome_produto: action.payload };
    case MovimentacaoFundosActions.setNumero_proposta:
      return { ...state, numero_proposta: action.payload };
    case MovimentacaoFundosActions.setStatus:
      return { ...state, status: action.payload };
    case MovimentacaoFundosActions.setTelefone:
      return { ...state, telefone: action.payload };
    case MovimentacaoFundosActions.setValor_saldo:
      return { ...state, valor_saldo: action.payload };
    //Fundo origem
    case MovimentacaoFundosActions.setIdFundoOrigem:
      return { ...state, id_fundo_origem: action.payload };
    case MovimentacaoFundosActions.setSaldoInicial:
      return { ...state, saldo_inicial: action.payload };
    case MovimentacaoFundosActions.setNomeFundo:
      return { ...state, nome_fundo: action.payload };

    default:
      return state;
  }
};

// Load state from localStorage or use initial values
const loadStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem('movimentacaoFundosState');
    if (serializedState === null) {
      return initialValues;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return initialValues;
  }
};

// Save state to localStorage
const saveStateToLocalStorage = (state: State) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('movimentacaoFundosState', serializedState);
  } catch (error) {
    // Handle error while saving state
  }
};

//Provider
export const MovimentacaoFundosProvider = ({
  children
}: MovimentacaoFundosProviderProps) => {
  const [state, setState] = useReducer(
    MovimentacaoFundosReducer,
    loadStateFromLocalStorage() // Load state from localStorage
  );

  // Save state to localStorage whenever it changes
  useEffect(() => {
    saveStateToLocalStorage(state);
  }, [state]);

  const value = { state, setState };

  return (
    <MovimentacaoFundosContext.Provider value={value}>
      {children}
    </MovimentacaoFundosContext.Provider>
  );
};
